import Tabs from "./Tabs.vue";

export default Tabs;
